// 泰语
export const Thailand = {
  language_code: "th",
  get_btn: "รับทันที",
  unregistered_tip: "ผู้ใช้ที่ไม่ได้ลงทะเบียนจะสร้างบัญชีโดยตรง",
  phone_number: "เบอร์โทรศัพท์",
  ver_code: "รหัสยืนยัน",
  get_ver_code: "รับรหัส",
  retrieve_ver_code: "รับใหม่ ({SECONDS})",
  age_tip: "ฉันเป็นผู้ใหญ่และมีความสามารถทางกฎหมายอย่างเต็มที่ และยอมรับ ",
  and: "และ",
  PRIVICY_POLICY: '"นโยบายความเป็นส่วนตัว"',
  MEMBER_AGGREMENT: '"เงื่อนไขสมาชิก"',
  agree_push:
    "ข้าพเจ้ายอมรับการรับข้อมูลข่าวสารจากไหตี่เลาผ่านเบอร์โทรศัพท์หรืออีเมลที่ลงทะเบียนไว้",
  CN: "จีน",
  US: "สหรัฐอเมริกา",
  CA: "แคนาดา",
  GB: "สหราชอาณาจักร",
  MY: "มาเลเซีย",
  AU: "ออสเตรเลีย",
  ID: "อินโดนีเซีย",
  SG: "สิงคโปร์",
  TH: "ไทย",
  JP: "ญี่ปุ่น",
  KR: "เกาหลี",
  VN: "เวียดนาม",
  HK: "ฮ่องกง",
  MO: "มาเก๊า",
  HKM: "กัมพูชา",
  TW: "ไต้หวัน",
  PH: "ฟิลิปปินส์",
  UAE: "สหรัฐอาหรับเอมิเรตส์",
  suc_send: "ส่งเรียบร้อย",
  suc_get: "รับสำเร็จ",
  fail_ver_code: "รหัสไม่ถูกต้อง",
  time_end: "กิจกรรมจบลงแล้ว",
  not_get_repeat: "ไม่สามารถรับซ้ำได้!",
  not_get_eligible: "ไม่สามารถรับได้ ไม่ตรงตามเงื่อนไขกิจกรรม",
  not_get_late: "คุณช้าไปหนึ่งก้าว กิจกรรมจบลงแล้ว",
  get_coupon: "รับคูปอง",
  phone_err: "หมายเลขโทรศัพท์ไม่ถูกต้อง กรุณากรอกหมายเลขที่ถูกต้อง",
  page_title: "รับคูปองพิเศษ Haidilao",
  send_code_error: "ส่งรหัสยืนยันล้มเหลว",
  network_error: "การเชื่อมต่อเครือข่ายของคุณไม่เสถียร โปรดลองอีกครั้งภายหลัง",
  member_status_abnormal: "บัญชีสมาชิกผิดปกติ ไม่สามารถรับได้",
  send_frequently:
    "ส่งรหัสยืนยันมากเกินไป กรุณากรอกรหัสล่าสุดที่ได้รับหรือรอแล้วลองใหม่อีกครั้ง",
  activity_boom: "มีผู้รับสิทธิมากเกินไป กรุณาลองใหม่ภายหลัง",
  email: "อีเมล",
  email_error_tip: "อีเมลไม่ถูกต้อง กรุณากรอกอีเมลที่ถูกต้อง",
  suc_get_dialog_text: "เปิดแอปสมาชิก Haidilao ทันทีเพื่อดูคูปองที่ได้รับ!",
  btn_sure: "ตกลง",
  btn_cancel: "ยกเลิก",
  suc_dialog_text:
    "เปิดแอป Haidilao หรือผูกบัญชีสมาชิกผ่าน LINE เพื่อเช็กคูปองที่คุณได้รับ!",
  btn_return: "กลับ",
  btn_download: "ดาวน์โหลด",
};
